const initialState = {
  invoices: [],
  isLoading: false,
}

const invoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_INVOICE_LOADING":
      return {
        ...state,
        isLoading: action.data,
      }
    case `SET_INVOICES`:
      return {
        ...state,
        invoices: action.data,
      }
    default:
      return state
  }
}

export default invoicesReducer
